import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { IMAGES, offerIncludes } from '../data/coachSystem';
export function OfferSection() {
  return <section id="offer" className="scroll-mt-4 border-y border-navy-line bg-ivory-deep py-11 sm:py-14" aria-labelledby="offer-title" data-id="element-82" data-mp="8n58nwiw82h8">
      <div className="mx-auto w-full max-w-[42rem] px-4 text-center sm:px-6 lg:max-w-3xl" data-id="element-83" data-mp="dfyfcpxx9kvy">
        <p className="eyebrow text-[0.66rem] font-semibold text-teal sm:text-[0.72rem]" data-id="element-84" data-mp="ifaz31thybub">
          Get the complete system today
        </p>
        <h2 id="offer-title" className="mt-3 font-display text-[1.9rem] leading-[1.12] tracking-tight text-navy sm:text-[2.4rem]" data-id="element-85" data-mp="rdeowabilurx">
          Stop building every Girls Flag Football practice from scratch.
        </h2>
        <p className="mx-auto mt-4 max-w-[34rem] text-[0.98rem] leading-relaxed text-navy-muted" data-id="element-86" data-mp="2t7436o56d4pf">
          Get Girls Flag Football Coach System™ and bring skill development,
          play strategy, practice planning, season organization and
          ready-to-run practices into one organized professional coaching
          system.
        </p>

        <img src={IMAGES.bundle} alt="The complete Girls Flag Football Coach System™ bundle of six written coaching volumes." className="mx-auto -mb-1 mt-5 w-full max-w-[25rem] sm:max-w-[28rem]" data-id="element-87" data-mp="sx76jr0g3oiw" />

        <div className="mt-6 rounded-2xl border border-navy-line bg-white p-5 shadow-lift sm:p-8" data-id="element-88" data-mp="1llulz5yijjoj">
          <h3 className="font-display text-[1.15rem] leading-snug text-navy sm:text-[1.35rem]" data-id="element-89" data-mp="1gnt42octpqen">
            Get the complete Girls Flag Football Coach System™
          </h3>
          <p className="mt-1.5 text-[0.9rem] font-semibold text-teal-deep" data-id="element-90" data-mp="17nefng4kbv6x">
            6 Professional Volumes + 5 Practical Bonuses
          </p>

          <ul className="mx-auto mt-5 max-w-sm space-y-2 text-left" data-id="element-91" data-mp="14g95d70zts2">
            {offerIncludes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-92" data-mp="3ttzswb5v8ip9">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-93" data-mp="3tusqommujxv9" />
                <span className="text-[0.92rem] font-medium text-navy" data-id="element-94" data-mp="3ktl2ixe1odew">
                  {item}
                </span>
              </li>)}
          </ul>

          <div id="pricing" className="mt-6 scroll-mt-6 border-t border-navy-line pt-6" data-id="element-95" data-mp="3owzk3shmt1ug">
            <p className="text-[0.85rem] text-navy-muted" data-id="element-96" data-mp="3ftyfxxcbtktf">
              Complete Resource Value:{' '}
              <span className="font-medium line-through" data-id="element-97" data-mp="315lu3t6ydicn">$97</span>
            </p>
            <p className="mt-2 font-display text-[4.5rem] font-semibold leading-[0.85] text-navy sm:text-[5.5rem]" data-id="element-98" data-mp="313hi0nywhd1a">
              $27
              <span className="ml-1.5 align-super text-[1.1rem] font-semibold tracking-wide text-navy-muted sm:text-[1.35rem]" data-id="element-99" data-mp="2s4dwldc9gljm">
                USD
              </span>
            </p>
            <p className="mt-3 text-[0.85rem] text-navy-muted" data-id="element-100" data-mp="2dhf6blp53x6h">
              Pay in your local currency.
            </p>
            <p className="mt-2.5 text-[0.72rem] font-bold uppercase tracking-[0.18em] text-navy-muted" data-id="element-101" data-mp="28jvuesfwzwhp">
              One-time payment
            </p>

            <CtaButton label="Get instant access" action="checkout" size="lg" className="mt-5" data-id="element-102" data-mp="2mgaev4fnpjcy" />
            <p className="mt-3 text-[0.82rem] text-navy-muted" data-id="element-103" data-mp="2wf898nzrk73v">
              Instant digital access
            </p>
          </div>
        </div>

        <div className="mx-auto mt-5 flex max-w-xl items-start gap-3 text-left" data-id="element-104" data-mp="366mcn6uu5r2a">
          <ShieldCheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-teal" aria-hidden="true" data-id="element-105" data-mp="368fd24euvf1u" />
          <div data-id="element-106" data-mp="3f6rbgslyrh4u">
            <h3 className="text-[0.72rem] font-bold uppercase tracking-[0.14em] text-navy" data-id="element-107" data-mp="3f6ivgrujnvpf">
              7-day money-back guarantee
            </h3>
            <p className="mt-1 text-[0.85rem] leading-relaxed text-navy-muted" data-id="element-108" data-mp="3a6d1v64prz4p">
              Explore Girls Flag Football Coach System™ for seven days. If it
              isn’t the right fit for your coaching needs, contact us within the
              guarantee period according to the stated refund policy.
            </p>
          </div>
        </div>
      </div>
    </section>;
}